import oldBrowserCheck from '@spinnwerk/old-browser-check';

export default function ({
    selector = '.browser-alert--browsehappy',
    closeSelector = '.js-close-browser-alert-info',
} = {}) {
    const $element = $(selector),
        oldBrowser = oldBrowserCheck({
            ie: '11',
            firefox: '60',
            chrome: '66',
            opera: '50',
            safari: '11',
            android: '7.0',
        });

    // if the cookie doesn't exist yet, show the info
    if (oldBrowser) {
        $element.show();

        // init the close click to fade out the element
        $(closeSelector).click(function (event) {
            event.preventDefault();
            $element.fadeOut();
        });
    }
}
